export default "__VITE_ASSET__CjDKjBT9__"